import { useMutation } from "@tanstack/react-query";
import domainsService, { type DomainRequestReq } from "@stringf/services/domains";

/**
 * Submits a Domain request. A mutation with no cache to touch: nothing a client
 * reads changes when one is filed, and no retry, since a repeat is refused by the
 * server as a duplicate.
 */
export function useRequestDomain() {
  return useMutation({
    mutationFn: (body: DomainRequestReq) => domainsService.requestDomain(body),
    retry: false,
  });
}
